import { render, staticRenderFns } from "./ForwarderSchedule.vue?vue&type=template&id=6a483d24&scoped=true"
import script from "./ForwarderSchedule.vue?vue&type=script&lang=js"
export * from "./ForwarderSchedule.vue?vue&type=script&lang=js"
import style0 from "./ForwarderSchedule.vue?vue&type=style&index=0&id=6a483d24&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a483d24",
  null
  
)

export default component.exports